module.exports = __webpack_public_path__ + "static/media/icon_pulldown_active.bfbd02da.svg";